import { darkTheme, lightTheme } from '../theme/theme'

export const themeData = {
    theme: darkTheme,
    darkTheme,
    lightTheme
}